import fr from '@bc-library/translation/locales/fr.json'
import en from '@bc-library/translation/locales/en.json'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  locale: window.navigator.language.includes('fr') ? 'fr' : 'en',
  fallbackLocale: 'fr',
  legacy: false,
  globalInjection: true,
  messages: { fr, en },
})

// Re-apply locale JSON after module evaluation so Vite HMR / transform
// caches cannot leave createI18n with a stale snapshot.
i18n.global.setLocaleMessage('fr', fr as any)
i18n.global.setLocaleMessage('en', en as any)

// Keep locale messages in sync when JSON files change during Vite HMR.
// Without this, createI18n keeps the initial snapshot and UI stays stale.
// Paths must be relative (Vite HMR does not resolve aliases in accept()).
if (import.meta.hot) {
  import.meta.hot.accept(
    [
      '@bc-library/translation/locales/fr.json',
      '@bc-library/translation/locales/en.json',
      '../../../../packages/translation/src/locales/fr.json',
      '../../../../packages/translation/src/locales/en.json',
    ],
    ([newFr, newEn]) => {
      if (newFr) {
        i18n.global.setLocaleMessage('fr', newFr.default ?? newFr)
      }
      if (newEn) {
        i18n.global.setLocaleMessage('en', newEn.default ?? newEn)
      }
    },
  )
}

export default i18n
